export default __webpack_public_path__ + "static/media/openaire-10.d475f4dd.jpg";